import DefaultLayout from './DefaultLayout.vue'
import AuthLayout from './AuthLayout.vue';

export default {
  DefaultLayout,
  AuthLayout
}